module.exports = __webpack_public_path__ + "assets/retina_AnnulusDetailed.b9ec70e55a995f5531f577b84905663c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_AnnulusDetailed.png
// module id = 623
// module chunks = 0